import type { SportProfile } from '@/types'

export const rugbyUnion: SportProfile = {
  id: 'rugby-union',
  sport: 'rugby',
  gender: 'coed',
  environment: 'outdoor',
  label: 'Rugby Union (15s)',
  emoji: '🏉',
  playersOnField: 15,
  contactLevel: 'full',
  hasShotClock: false,
  periods: { label: 'Half', count: 2, durationMinutes: 40 },
  positions: [
    { key: 'loosehead_prop',  label: 'Loosehead Prop',   shortLabel: 'LP',  maxOnField: 1 },
    { key: 'hooker',          label: 'Hooker',            shortLabel: 'HK',  maxOnField: 1 },
    { key: 'tighthead_prop',  label: 'Tighthead Prop',   shortLabel: 'TP',  maxOnField: 1 },
    { key: 'lock',            label: 'Lock',              shortLabel: 'LK'                 },
    { key: 'blindside',       label: 'Blindside Flanker', shortLabel: 'BF',  maxOnField: 1 },
    { key: 'openside',        label: 'Openside Flanker',  shortLabel: 'OF',  maxOnField: 1 },
    { key: 'number_8',        label: 'Number 8',          shortLabel: 'N8',  maxOnField: 1 },
    { key: 'scrum_half',      label: 'Scrum-half',        shortLabel: 'SH',  maxOnField: 1 },
    { key: 'fly_half',        label: 'Fly-half',          shortLabel: 'FH',  maxOnField: 1 },
    { key: 'centre',          label: 'Centre',            shortLabel: 'CTR'                },
    { key: 'winger',          label: 'Winger',            shortLabel: 'WG'                 },
    { key: 'fullback',        label: 'Fullback',          shortLabel: 'FB',  maxOnField: 1 },
  ],
  stats: [
    { key: 'try',             label: 'Try',               shortLabel: 'T'    },
    { key: 'conversion',      label: 'Conversion',        shortLabel: 'CON'  },
    { key: 'penalty_goal',    label: 'Penalty Goal',      shortLabel: 'PG'   },
    { key: 'drop_goal',       label: 'Drop Goal',         shortLabel: 'DG'   },
    { key: 'assist',          label: 'Try Assist',        shortLabel: 'A'    },
    { key: 'tackle',          label: 'Tackle',            shortLabel: 'TCK'  },
    { key: 'line_break',      label: 'Line Break',        shortLabel: 'LB'   },
    { key: 'offload',         label: 'Offload',           shortLabel: 'OFL'  },
    { key: 'caused_turnover', label: 'Turnover Won',      shortLabel: 'TW'   },
    { key: 'turnover',        label: 'Turnover Lost',     shortLabel: 'TL'   },
    { key: 'yellow_card',     label: 'Yellow Card',       shortLabel: 'YC',  statType: 'card' },
    { key: 'red_card',        label: 'Red Card',          shortLabel: 'RC',  statType: 'card' },
  ],
}
